/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { guidCreatedOrUpdatedEntityModelSchema } from "../guidCreatedOrUpdatedEntityModelSchema.ts";
import { updateAdminModelSchema } from "../updateAdminModelSchema.ts";
import { z } from "zod";

export const putApiAdminsIdPathParamsSchema = z.object({
    "Id": z.string().uuid().describe("Идентификатор")
    })

/**
 * @description Администратор обновлен
 */
export const putApiAdminsId200Schema = z.lazy(() => guidCreatedOrUpdatedEntityModelSchema)

/**
 * @description Администратор с таким логином уже существует | Ошибка валидации
 */
export const putApiAdminsId400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const putApiAdminsId401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const putApiAdminsId403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Администратор не найден
 */
export const putApiAdminsId404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const putApiAdminsId500Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Тело запроса
 */
export const putApiAdminsIdMutationRequestSchema = z.lazy(() => updateAdminModelSchema).describe("Тело запроса")

export const putApiAdminsIdMutationResponseSchema = z.lazy(() => putApiAdminsId200Schema)